import { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";

export default function EmailGate({ onStart, loading }) {
  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState(false);
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const submit = (e) => {
    e.preventDefault();
    setTouched(true);
    if (!valid) return;
    onStart(email.trim().toLowerCase());
  };

  return (
    <div className="min-h-screen bg-cream-grain flex items-center justify-center px-5 py-10" data-testid="email-gate">
      <div className="w-full max-w-3xl">
        <div className="text-center mb-10">
          <div className="text-[10px] tracking-[0.45em] uppercase text-[#CD7F32] font-semibold mb-3">
            Scholar Athlete Academy · Admissions
          </div>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1B3B2B] leading-[1.05] tracking-tight">
            Begin Your Enrollment.
          </h1>
          <p className="mt-5 max-w-xl mx-auto text-[#4B5563] text-base sm:text-lg leading-relaxed">
            A focused, fourteen-step process to formally enroll your student. Your
            progress is saved by email — pause and resume any time on any device.
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-white border border-[#E5E0D8] rounded-sm p-6 sm:p-10 shadow-sm"
        >
          <label className="label-eyebrow block" htmlFor="gate-email">
            Parent / Guardian Email
          </label>
          <div className="flex flex-col sm:flex-row gap-3 mt-3">
            <div className="flex-1 relative">
              <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#8BA596]" />
              <input
                id="gate-email"
                data-testid="gate-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={() => setTouched(true)}
                placeholder="parent@example.com"
                className="w-full bg-white border-2 border-[#E5E0D8] rounded-sm pl-11 pr-4 py-3.5 font-medium text-[#1A1A1A] focus:outline-none focus:border-[#1B3B2B] transition-colors"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="gate-start-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#1B3B2B] text-white hover:bg-[#132A13] disabled:opacity-60 transition-colors rounded-sm px-7 py-3.5 font-semibold uppercase tracking-wider text-sm"
            >
              {loading ? "Loading…" : "Begin"} <ArrowRight size={16} />
            </button>
          </div>
          {touched && !valid && (
            <p className="mt-3 text-sm text-[#991B1B]">Please enter a valid email address.</p>
          )}
          <p className="mt-6 text-xs text-[#4B5563] leading-relaxed">
            We use your email solely to save your enrollment progress and deliver your signed
            agreement. No marketing — ever.
          </p>
        </form>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8 text-center">
          {[
            { k: "14", v: "Sections" },
            { k: "~12", v: "Minutes" },
            { k: "100%", v: "Auto-Saved" },
          ].map((s) => (
            <div key={s.v} className="bg-white/60 border border-[#E5E0D8] rounded-sm py-5">
              <div className="font-serif-display text-3xl text-[#1B3B2B]">{s.k}</div>
              <div className="label-eyebrow mt-1">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
